
<template>
  <el-form-item :label="params.label" class="watsonDaterange" style="width:420px;">
    <el-date-picker
      v-if="showTimeRange"
      class="w350"
      size="small"
      v-model="dataRange"
      type="datetimerange"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      @focus="focus"
      @blur="blur"
      :default-time="defaultTime">
    </el-date-picker>
  </el-form-item>
</template>

<script>
import { dateFormat } from '@/utils/tools'
export default {
  name: 'form-dataRange',
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      showTimeRange: true,
      dataRange: this.params.start && this.params.end ? [new Date(this.params.start), new Date(this.params.end)] : null,
      defaultTime: [dateFormat(new Date(), 'hh:mm:ss'), dateFormat(new Date(), 'hh:mm:ss')]
    }
  },
  created() {},
  methods: {
    focus() {
      this.defaultTime = [dateFormat(new Date(), 'hh:mm:ss'), dateFormat(new Date(), 'hh:mm:ss')]
    },
    blur() {
      const vm = this
      vm.showTimeRange = false
      setTimeout(() => {
        vm.showTimeRange = true
      }, 30)
    },
    reset() {
      if (this.params.dValue) {
        this.dataRange = this.params.dValue
      } else {
        this.dataRange = undefined
      }
    },
    getValue() {
      if (this.dataRange && this.dataRange.length) {
        if (this.params.key !== 'time') {
          return {
            [this.params.key + 'StartTime']: dateFormat(this.dataRange[0], 'yyyy-MM-dd hh:mm:ss'),
            [this.params.key + 'EndTime']: dateFormat(this.dataRange[1], 'yyyy-MM-dd hh:mm:ss')
          }
        } else {
          return {
            startTime: dateFormat(this.dataRange[0], 'yyyy-MM-dd hh:mm:ss'),
            endTime: dateFormat(this.dataRange[1], 'yyyy-MM-dd hh:mm:ss')
          }
        }
      }
      return undefined
    }
  },
  watch: {
    dataRange(nv, ov) {
      const cp = JSON.parse(JSON.stringify(this.params))
      if (nv) {
        cp.start = dateFormat(nv[0], 'yyyy-MM-dd hh:mm:ss')
        cp.end = dateFormat(nv[1], 'yyyy-MM-dd hh:mm:ss')
      } else {
        cp.start = undefined
        cp.end = undefined
      }
      this.$emit('csi', cp)
    }
  }
}
</script>

<style lang="less">
@import "../miBicycle.less";
</style>
